import DeploymentsRoute from "./DeploymentsRoute";
export * from "./DeploymentsRoute";
export * from "./deploymentRouteLinks";

export default DeploymentsRoute;
